function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconaccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.448,
    height: 11.448,
    viewBox: "0 0 11.448 11.448",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1395",
    d: "M-4.7-18.047a5.306 5.306 0 0 1 2.737.739 5.531 5.531 0 0 1 2 2 5.306 5.306 0 0 1 .739 2.737 5.306 5.306 0 0 1-.739 2.735 5.531 5.531 0 0 1-2 2A5.306 5.306 0 0 1-4.7-7.1a5.306 5.306 0 0 1-2.737-.739 5.531 5.531 0 0 1-2-2 5.306 5.306 0 0 1-.739-2.737 5.306 5.306 0 0 1 .739-2.737 5.531 5.531 0 0 1 2-2 5.306 5.306 0 0 1 2.737-.734zm0 2.119a1.868 1.868 0 0 0-1.369.574 1.868 1.868 0 0 0-.574 1.369 1.868 1.868 0 0 0 .574 1.369 1.868 1.868 0 0 0 1.369.574 1.868 1.868 0 0 0 1.369-.574 1.868 1.868 0 0 0 .574-1.369 1.868 1.868 0 0 0-.574-1.369 1.868 1.868 0 0 0-1.369-.574zm0 7.593a4.2 4.2 0 0 0 1.8-.4 4.189 4.189 0 0 0 1.446-1.1 2.635 2.635 0 0 0-.9-.96 2.34 2.34 0 0 0-1.28-.364.649.649 0 0 0-.155.022 2.853 2.853 0 0 1-.9.155 2.853 2.853 0 0 1-.9-.155.649.649 0 0 0-.155-.022 2.34 2.34 0 0 0-1.28.364 2.635 2.635 0 0 0-.9.96A4.189 4.189 0 0 0-6.5-8.732a4.2 4.2 0 0 0 1.8.397z",
    transform: "translate(10.422 18.297)",
    style: {
      fill: "none",
      stroke: "#5a5a5a",
      strokeWidth: ".5px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconaccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.account.fd437b048ac01cd4dc598ddd24813cb3.svg";